import auth from '../modules/authentication/triggers';
import routing from '../modules/routing/triggers';
import customer from './customer/triggers';

export default { auth, routing, customer };



// WEBPACK FOOTER //
// ./src/frontend/admin/triggers.js